import styled from 'styled-components';

export const PanelWrapper = styled.div`
  padding: 0;
`;

export const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px !important;
  border-bottom: 1px solid #EAEDF0;

  .headerLabel {
    font-size: 12px;
    font-weight: 600;
    color: #8697A8;
  }

  .headerValue {
    font-size: 12px;
    font-weight: 400;
    color: #324150;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CategoryPanel = styled.div`
  padding: 0 8px !important;
  padding-bottom: 8px !important;

  .ant-collapse {
    background: transparent;
    border: none;
  }

  .ant-collapse-item {
    border-bottom: 1px solid #EAEDF0;
  }

  .ant-collapse-header {
    font-size: 12px;
    font-weight: 600;
    color: #44566C;
    padding: 10px 16px !important;
  }

  .ant-collapse-expand-icon {
    padding-inline-start: 4px !important;
    margin-inline-end: 4px !important;
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export const PropertyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px 6px 36px;
  border-bottom: 1px solid #F5F5F5;

  &:last-child {
    border-bottom: none;
  }

  .propLabel {
    font-size: 11px;
    color: #8697A8;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .propValue {
    font-size: 11px;
    color: #324150;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
  }

  .propValueRight {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .sumBadge {
    font-size: 10px;
    color: #8697A8;
  }
`;

export const VariedRow = styled(PropertyRow)`
  cursor: pointer;
  user-select: none;
  padding-left: 20px;

  .propLabelGroup {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .propValue {
    color: #6B7B8C;
    font-style: italic;
  }

  .chevron {
    font-size: 10px;
    color: #8697A8;
    transition: transform 0.15s ease;
  }

  &.is-open .chevron {
    transform: rotate(90deg);
  }
`;

export const SubPropertyList = styled.div`
  background: #FAFBFC;
  border-bottom: 1px solid #F5F5F5;
`;

export const SubPropertyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 16px 5px 56px;

  .subIndex {
    font-size: 11px;
    color: #8697A8;
    min-width: 24px;
  }

  .subValue {
    font-size: 11px;
    color: #324150;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px !important;
  gap: 12px;

  img {
    width: 120px;
    height: auto;
    opacity: 0.6;
  }

  p {
    font-size: 13px;
    color: #8697A8;
    margin: 0;
  }
`;
